export default __webpack_public_path__ + "static/media/calendar-outline-16px.e3af0a17.svg";